const id_other_cost = {
    "": "biaya lainnya",
    add: "tambah biaya lainnya",
    edit: "ubah biaya lainnya",

    label: {
        name: 'nama biaya',
        type: 'jenis biaya',
        coa_debit: 'COA debit',
        coa_credit: 'COA kredit',
    },
    error: {
        name: "Nama biaya tidak boleh kosong.",
        type: "Jenis biaya tidak boleh kosong.",
        coa_debit: "COA debit tidak boleh kosong.",
        coa_credit: "COA kredit tidak boleh kosong.",
        create: "Gagal membuat biaya lainnya.",
        delete: "Gagal menghapus biaya lainnya.",
        edit: "Gagal mengubah biaya lainnya.",
    },
    success: {
        create: "Berhasil membuat biaya lainnya.",
        delete: "Berhasil menghapus biaya lainnya.",
        edit: "Berhasil mengubah biaya lainnya.",
    },
}

export default id_other_cost;